<section
  class="flex h-full w-full items-center gap-2 pr-0 text-white lg2:gap-4 lg2:pr-4 xl:gap-8 xl:pr-8"
  aria-labelledby="ticket-type-breakdown-heading"
  [attr.aria-busy]="isLoading()"
>
  <h3 id="ticket-type-breakdown-heading" class="sr-only">
    Ticket type breakdown
  </h3>
  <!-- Donut chart -->
  @if (isLoading()) {
    <div
      class="flex h-[90px] w-[90px] shrink-0 items-center justify-center lg2:h-[120px] lg2:w-[120px] xl:h-[160px] xl:w-[160px]"
      role="status"
      aria-label="Loading ticket type breakdown"
    >
      <div class="loading-spinner">
        <mat-spinner [diameter]="40" aria-hidden="true"></mat-spinner>
      </div>
    </div>
  } @else if (!pieChartData?.datasets?.[0]?.data?.length) {
    <div
      class="flex h-[90px] w-[90px] shrink-0 items-center justify-center rounded-full border-[12px] border-white/10 lg2:h-[120px] lg2:w-[120px] lg2:border-[16px] xl:h-[160px] xl:w-[160px] xl:border-[20px]"
      role="img"
      aria-label="No ticket type data available"
    >
      <span class="text-center text-xs leading-tight text-white/50"
        >No tickets</span
      >
    </div>
  } @else {
    <div
      class="h-[90px] w-[90px] shrink-0 overflow-hidden drop-shadow lg2:h-[120px] lg2:w-[120px] xl:h-[160px] xl:w-[160px]"
    >
      <canvas
        baseChart
        [data]="pieChartData"
        [options]="pieChartOptions"
        [labels]="pieChartData.labels"
        [type]="pieChartType"
        role="img"
        class="h-full w-full"
        [attr.aria-label]="chartAriaLabel()"
      ></canvas>
    </div>
  }

  <!-- Legend -->
  <div class="flex min-w-0 flex-1 flex-col justify-center gap-1.5 lg2:gap-2">
    <div
      class="space-y-1.5 lg2:space-y-2"
      role="list"
      aria-label="Ticket type percentages"
    >
      @for (item of legendItems(); track item.label) {
        <div class="flex items-center gap-1.5 lg2:gap-2" role="listitem">
          <span
            class="h-3 w-3 shrink-0 rounded-sm lg2:h-3.5 lg2:w-3.5"
            [style.backgroundColor]="item.color"
            aria-hidden="true"
          ></span>
          <span class="font-lato text-xs text-white/90 lg2:text-sm">{{
            item.label
          }}</span>
          <span class="font-lato text-xs font-bold text-white lg2:text-sm">{{
            item.count
          }}</span>
        </div>
      }
      @if (!legendItems().length && !isLoading()) {
        <p class="font-lato text-sm text-white/50" role="status">
          No ticket data available
        </p>
      }
    </div>
  </div>
</section>
